module.exports = __webpack_public_path__ + "static/media/20200417_161057.7c4494cf.jpg";